"use client";

import { createContext, useContext, type ReactNode } from "react";

const CompanyIntegrationsAccessContext = createContext(false);

export function AdminNavigationAccessProvider({
  canManageCompanyIntegrations,
  children,
}: {
  canManageCompanyIntegrations: boolean;
  children: ReactNode;
}) {
  return (
    <CompanyIntegrationsAccessContext.Provider value={canManageCompanyIntegrations}>
      {children}
    </CompanyIntegrationsAccessContext.Provider>
  );
}

export function useCompanyIntegrationsAccess(): boolean {
  return useContext(CompanyIntegrationsAccessContext);
}
